module.exports = __webpack_public_path__ + "static/media/spin.b028b7bb.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/spin.gif
 ** module id = 1444
 ** module chunks = 0
 **/